import {DynamicPriceRestrictionTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class DynamicPriceRestrictionTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in DynamicPriceRestrictionTypeCd ) {
      this._values.push(DynamicPriceRestrictionTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): DynamicPriceRestrictionTypeCd {

    for ( const obj in DynamicPriceRestrictionTypeCd ) {
      if (DynamicPriceRestrictionTypeCd[obj] === value){
        return DynamicPriceRestrictionTypeCd[obj] as DynamicPriceRestrictionTypeCd;
      }
    }
  }
}

const DynamicPriceRestrictionTypeCdHelper = new DynamicPriceRestrictionTypeCdHelperEnumHelperClass();
export default DynamicPriceRestrictionTypeCdHelper;
